<template>
	<Loading :loading="loading || wpContentLoaded" class="row">
		<WordpressContentPage
			:pageSlug="pageSlug"
			class="col-12"
			:showLoading="false"
			@loaded="() => {wpContentLoaded = false}"
		/>
		<div class="container">
			<div class="col-12 row" v-for="(item) of categories" :key="item.id">
				<h2 class="col-12 windowShopCatHeader">
					<router-link
						:to="link(item.cat)"
					>
						{{item.cat}}
					</router-link>
				</h2>
				<ListItem 
					v-for="(product) of item.products"
					:item = "product"
					:key="product.id"
					:source="'window'"
					class="col-12 col-md-3"
				/>
			</div>
		</div>

		<vue-headful
			title="Window Shop | Cherrytree"
			description="Browse some of the great savings you can have at Cherrytree"
		/>
	</Loading>
</template>

<script>

import WordpressContentPage from "@/wordpress/WordpressContentPage";
import Loading from "@/components/loading/Loading";
import { getWindowShop, getSingleWindowItems } from "@/network/windowShopRequests";
import ListItem from "@/sections/shop/listing/ListItem";

export default {
	name: 'WindowShop',
	data() {
		return {
			items: [],
			loading: true,
			wpContentLoaded: true,
		};
	},
	props: ["pageSlug"],
	components: {
		Loading,
		ListItem,
		WordpressContentPage,
	},
	created() {
		this.getData();
	},
	methods: {
		getData() {
			let cats = {
				"Big Ticket" : "Big Ticket Items",
				"Baby": "Baby Items",
				"Building Renovations": "New Builds and Renovations",
				"Everyday": "Everyday Items"
			}
			getWindowShop(
				(res) => {
					for (let cat of res) {
						let grouping = {id: cat.id, cat: cats[cat.windowshop], products: []}
						getSingleWindowItems({id: cat.id},
							(windowItems) => {
								// console.log(windowItems)
								grouping.products = windowItems;
								this.items.push(grouping)
								this.loading=false;
							},
							(err) => {
								// console.log(err.products)
							}
						)
					}
				},
				(err) => {
					// console.log(err)
				}

			)
		},
		link(cat) {
			// console.log(cat)
			if (cat != undefined) {
				switch (cat.toLowerCase()){
					case "baby items":
						return {name: "baby-items"};
					case "big ticket items":
						return {name: "big-ticket-items"};
					case "everyday items":
						return {name: "everyday-items"};
					case "new builds and renovations":
						return {name: "build-reno-items"};
					default :
						return {name: "window-shop"};
				}
			}
			return {name: "window-shop"};
		},
	},
	computed: {
		categories() {
			let x = this.items;
			return x.sort((a,b)=>{return a.id-b.id})
		},
		cats() {
			return this.items.map(({cat}) => cat);
		}
	}
}
</script>

<style lang="scss" scoped>
	.windowShopCatHeader {
		margin-top: 40px;
		a {
			color: $CTred;
		}
	}
</style>